<!--
 * @Author: your name
 * @Date: 2021-09-02 17:48:11
 * @LastEditTime: 2021-09-13 09:45:52
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/combinationCourse/combinnationActivity/activityPrice.vue
-->
<template>
  <div class="activity-price">
    <StraightDownPrice
      v-if="activeType === 1"
      :nowAcvitity="nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
    />
    <SeckillPrice
      v-else-if="activeType === 2 || activeType === 3"
      :nowAcvitity="nowAcvitity"
      :currentTime="currentTime"
      @triggerGetActive="receiveGetActive"
    />
    <CouponPrice v-else-if="activeType === 4" :nowAcvitity="nowAcvitity" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { reqCombinationAcvitity } from '@/api/combination';
// import { reqCurrentTime } from '@/api/courseDetail/index';
import { replaceHyphens } from '@/utils/tools';
import SeckillPrice from './seckillPrice.vue';
import CouponPrice from './couponPrice.vue';
import StraightDownPrice from './straightDownPrice.vue';

export default {
  components: {
    SeckillPrice,
    CouponPrice,
    StraightDownPrice,
  },
  data() {
    return {
      allAcvitityInfo: {}, // 产品详情页所有的活动数据
      activeType: 0, // 活动类型  0无单品促销活动  1 直降 2 限时秒杀 3 限量秒杀  4优惠券  5 拼团 6分享
      nowAcvitity: {}, //  当前展示的活动信息
      currentTime: 0,
    };
  },
  computed: {
    ...mapState(['courseBaseData', 'userInfo']),
  },
  watch: {
    userInfo() {
      // 登录成功查询活动接口，为了更新优惠券列表状态
      this.getAcvitity();
      // this.getServerTime();
    },
    courseBaseData() {
      // this.getServerTime();
      this.getAcvitity();
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 服务器时间
    // async getServerTime() {
    //   const current = await reqCurrentTime();
    //   this.currentTime = current.data
    //     ? new Date(replaceHyphens(current.data)).getTime()
    //     : new Date().getTime();
    // },
    // 查询所有活动接口
    async getAcvitity() {
      const activeType = 0;
      const nowAcvitity = {};
      Object.assign(this.allAcvitityInfo, { activeType, nowAcvitity });
      this.saveAcvitity();
    },
    // 活动保存到vuex
    saveAcvitity() {
      this.$store.dispatch('saveAllAcvitity', this.allAcvitityInfo);
    },
    // 更新活动状态
    receiveGetActive() {
      // this.getServerTime();
      this.getAcvitity();
    },
  },
};
</script>
<style lang="scss" scoped>
.activity-price {
  width: 100%;
}
</style>
